import { createContext, useContext } from 'react';
import { ModalProps } from '../types';

interface ModalContextType extends Pick<ModalProps, 'isOpen' | 'centered'> {
    close: ModalProps['onClose'];
    open: ModalProps['onOpen'];
    isDark: boolean;
    isFullscreen?: boolean;
}

export const ModalContext = createContext<ModalContextType>({} as ModalContextType);

export const useModalContext = () => {
    const context = useContext(ModalContext);
    if (context === undefined) {
        throw new Error('useModalContext must be used within a ModalContextProvider');
    }
    return context;
};
